<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">마이페이지</h1>
      <h2 class="page-tit">취약점 신고 결과 조회</h2>
    </section>
    <!-- <Report_timeline timelineClass="type-big" /> -->
    <Tabs
      :tabs="['취약점 정보', '자체 평가', '문의 접수']"
      v-model="selectedTab"
      role="tablist"
    />
    <div
      v-show="selectedTab === 0"
      id="tabpanel-0"
      role="tabpanel"
      :aria-labelledby="'tab-0'"
    >
      취약점 정보 내용
    </div>
    <div
      v-show="selectedTab === 1"
      id="tabpanel-1"
      role="tabpanel"
      :aria-labelledby="'tab-1'"
    >
      자체 평가 내용
    </div>
    <div
      v-show="selectedTab === 2"
      id="tabpanel-2"
      role="tabpanel"
      :aria-labelledby="'tab-2'"
    >
      <div class="chat__wrap">
        <div class="chat__mid">
          <!--채팅내용 스크롤-->
          <div class="chat__mid__scroll-body">
            <!--받은 대화-->
            <div class="chat__get">
              <div class="chat__profile">
                <img src="../../assets/img/noimg_profile.png" alt="프로필" />
              </div>
              <div class="chat__info-area">[문의 및 요청 시 안내]</div>
              <div class="chat__box">
                반갑습니다! 아래에서 신고하신 취약점의 문의 사항 및 추가 자료를
                등록 하실 수 있습니다.(최대 100,000자)<br />
                <span class="u-color-red"
                  >※ 이미지 허용 확장자 : png, jpg, gif / 첨부파일 허용 확장자 :
                  pdf, xlsx, xls, zip, tar, .7z / 최대 사이즈 : 150MB</span
                >
              </div>
            </div>
            <!--//받은 대화-->
            <!--보낸 대화-->
            <div class="chat__send">
              <div class="chat__info-area">2024-12-26 12:59:00</div>
              <div class="chat__box">
                안녕하세요. <br />
                취약점 관련 신고 하려고 하는데 <br />
                어떻게 해야 될지 몰라서요
              </div>
              <div class="chat__img">
                <img src="../../assets/img/no_img.jpg" alt="" />
              </div>
            </div>
            <!--//보낸 대화-->
            <!--받은 대화-->
            <div class="chat__get">
              <div class="chat__profile">
                <img src="../../assets/img/noimg_profile.png" alt="프로필" />
              </div>
              <div class="chat__info-area">[답변]2024-12-26 12:59:00</div>
              <div class="chat__box">
                네 문의 잘 주셨습니니다. <br />
                취약점 관련 신고에 대해서 자세히 말씀 드리겠습니다. <br />
                우선은.......
              </div>
              <div class="chat__box">홈페이지에 접속하셔서......</div>
            </div>
            <!--//받은 대화-->
            <!--채팅일-->
            <div class="chat__date-area">
              <span>2023, 05, 11</span>
            </div>
            <!--보낸 대화-->
            <div class="chat__send">
              <div class="chat__info-area">2024-12-26 12:59:00</div>
              <div class="chat__img">
                <img src="../../assets/img/no_img.jpg" alt="" />
              </div>
            </div>
            <!--//보낸 대화-->
            <!--받은 대화-->
            <div class="chat__get">
              <div class="chat__profile">
                <img src="../../assets/img/noimg_profile.png" alt="프로필" />
              </div>
              <div class="chat__info-area">[답변]2024-12-26 12:59:00</div>
              <div class="chat__img">
                <img src="../../assets/img/no_img.jpg" alt="" />
              </div>
            </div>
          </div>
          <!--메시지 입력-->
          <div class="chat__bottom">
            <div class="chat__bottom__btns">
              <button
                type="button"
                class="btn btn--white_light btn--line btn--icon btn_file"
              >
                <i class="svg_icon icon_file"></i>
              </button>
              <button
                type="button"
                class="btn btn--white_light btn--line btn--icon btn_photo"
              >
                <i class="svg_icon icon_photo"></i>
              </button>
            </div>
            <div class="chat__bottom__input__area">
              <label for="chat-input" class="sr-only">메시지 입력창</label>
              <textarea
                placeholder="내용 입력"
                class="chat__textarea"
                id="chat-input"
              ></textarea>
              <p class="chat__textarea-txt" aria-live="polite">0/100,000</p>
            </div>
            <button class="btn btn--blue btn_send">등록하기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Report_timeline from "../../component/Report_timeline.vue";
import Tabs from "../../component/Tabs.vue";
import "@/assets/scss/chat.scss";
import { ref } from "vue";
export default {
  components: {
    Tabs,
    // Report_timeline,
  },
  setup() {
    // data 정의
    const selectedTab = ref(2);
    // html에서 사용될 데이터 정의
    return {
      selectedTab,
    };
  },
};
</script>